// import { SettingsGearIcon, SignOutIcon } from '@/assets/svgIcons'
// import { AvatarComponent } from '@/components/atom/avatar/avatar'
// import {
//   Popover,
//   PopoverContent,
//   PopoverTrigger,
// } from '@/components/ui/popover'
// import { useAuth0 } from '@auth0/auth0-react'
// import packageJson from '@/../package.json'
// import { useNavigate } from 'react-router-dom'
// const appVersion = packageJson.version
// const build = packageJson.buildnumber
// // const buildNumber = import.meta.env.buildnumber || 'local-dev'

// export default function Profile() {
//   const { user, logout } = useAuth0()
//   const navigate = useNavigate()
//   const getInitials = (name?: string) => {
//     if (!name) return '?'
//     const words = name.split(' ')

//     if (words.length === 1) {
//       return words[0].substring(0, 2).toUpperCase()
//     }

//     return words
//       .map(n => n[0])
//       .join('')
//       .toUpperCase()
//   }

//   return (
//     <Popover>
//       <PopoverTrigger asChild>
//         <button className='items-center rounded-radius-full border-2 border-secondary '>
//           <AvatarComponent
//             src={user?.picture}
//             alt={'user'}
//             fallback={getInitials(user?.name).slice(0, 2)}
//           />
//         </button>
//       </PopoverTrigger>
//       <PopoverContent className='flex flex-col p-[0.75rem] items-start gap-[0.5rem]  rounded-[0.625rem] w-[17.1875rem] mr-2 border-2 border-border border-solid shadow-[0px_4px_4px_0px_rgba(129,129,129,0.25)] bg-primary'>
//         {/* Name row */}
//         <div className='flex items-center gap-[0.75rem] w-full'>
//           <button className='flex-shrink-0 items-center rounded-radius-full border-2 border-secondary border-solid'>
//             <AvatarComponent
//               src={user?.picture}
//               alt={'user'}
//               fallback={getInitials(user?.name).slice(0, 2)}
//             />
//           </button>
//           <h4 className='text-[1.125rem] text-primary-foreground font-semibold leading-tight'>
//             {user?.name}
//           </h4>
//         </div>
//         <div className='w-full h-[0.0625rem] bg-border' />
//         {/* Settings row */}
//         <div className='flex items-center gap-[0.75rem] w-full'>
//           <span
//             className='flex-shrink-0 flex items-center justify-center'
//             style={{ width: 38, height: 38 }}
//           >
//             <SettingsGearIcon />
//           </span>
//           <span
//             className='text-primary-foreground text-[1.125rem] font-medium leading-tight cursor-pointer hover:underline hover:text-info'
//             onClick={() => {
//               navigate('/settings')
//             }}
//           >
//             Settings
//           </span>
//         </div>
//         <div className='w-full h-[0.0625rem] bg-border' />
//         {/* Sign Out row */}
//         <div className='flex items-center gap-[0.75rem] w-full'>
//           <span
//             className='flex-shrink-0 flex items-center justify-center'
//             style={{ width: 38, height: 38 }}
//           >
//             <SignOutIcon />
//           </span>
//           <span
//             className='text-danger text-[1.125rem] font-medium cursor-pointer hover:underline'
//             onClick={() =>
//               logout({
//                 logoutParams: { returnTo: `${window.location.origin}/app` },
//               })
//             }
//           >
//             Sign Out
//           </span>
//         </div>
//         <div className='w-full h-[0.0625rem] bg-border' />
//         {/* Build Version row */}
//         <div className='flex justify-between bg-primary w-full pt-[0.25rem]'>
//           <p className='font-sans font-normal text-[14px] text-secondary-foreground'>
//             Build Version
//           </p>
//           <p className='font-sans font-normal text-[14px] text-secondary-foreground'>
//             v{appVersion} (Build {build})
//           </p>
//         </div>
//       </PopoverContent>
//     </Popover>
//   )
// }

import { SettingsGearIcon, SignOutIcon } from '@/assets/svgIcons'
import { AvatarComponent } from '@/components/atom/avatar/avatar'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { useAuth0 } from '@auth0/auth0-react'
import packageJson from '@/../package.json'
import { useNavigate } from 'react-router-dom'
import { BinocularsIcon } from '@/assets/icons/Binoculars'
import { useWebTour } from '../../contexts/WebTourContext'
import { setWebTour } from '@/redux-store/slices/menuItemSlice/menuItemSlice'
import { useAppDispatch } from '@/hooks/storeHooks/storehooks'

const appVersion = packageJson.version
const build = packageJson.buildnumber
// const buildNumber = import.meta.env.buildnumber || 'local-dev'

export default function Profile() {
  const { user, logout } = useAuth0()
  const navigate = useNavigate()
  const { startTour } = useWebTour()
  const dispatch = useAppDispatch()

  const getInitials = (name?: string) => {
    if (!name) return '?'
    const words = name.split(' ')

    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase()
    }

    return words
      .map(n => n[0])
      .join('')
      .toUpperCase()
  }

  function getAvatarFallback(name?: string, email?: string): string {
    if (name) {
      return getInitials(name).slice(0, 2)
    }
    if (email) {
      const local = email.split('@')[0]
      return local.slice(0, 2).toUpperCase()
    }
    return '?'
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          className='group relative items-center rounded-full p-[0.1875rem]
            transition-transform duration-300 ease-out
            hover:scale-[1.06] active:scale-[0.97]
            focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-info focus-visible:ring-offset-2'
        >
          {/* idle glow ring */}
          <span
            className='absolute inset-0 rounded-full opacity-60 blur-[6px]
              transition-opacity duration-300 group-hover:opacity-90'
            style={{
              background:
                'conic-gradient(from 0deg, #C8102E, #1E5FD9, #1E8A5F, #C8102E)',
            }}
            aria-hidden='true'
          />
          <span className='relative block rounded-full bg-primary p-[0.0625rem]'>
            <AvatarComponent
              src={user?.picture}
              alt={'user'}
              fallback={getInitials(user?.name).slice(0, 2)}
            />
          </span>
        </button>
      </PopoverTrigger>

      <PopoverContent
        className='w-[18.5rem] overflow-hidden rounded-[0.875rem] border border-border/60 p-0
          bg-primary shadow-[0_12px_32px_-8px_rgba(30,95,217,0.35)]
          animate-in fade-in-0 zoom-in-95 slide-in-from-top-1 duration-200 mr-2'
      >
        {/* Header banner: gradient identity card */}
        <div
          className='relative flex flex-col items-center gap-[0.625rem] overflow-hidden px-[1.25rem] pb-[1.125rem] pt-[1.375rem] rounded-radius-md'
          style={{
            background:
              'linear-gradient(135deg, #0B3FA8 0%, #1E5FD9 55%, #C8102E 130%)',
          }}
        >
          {/* ambient drifting blobs */}
          <span
            className='pointer-events-none absolute -left-6 -top-10 h-28 w-28 rounded-full bg-white/15 blur-2xl
              motion-safe:animate-[drift_7s_ease-in-out_infinite]'
            aria-hidden='true'
          />
          <span
            className='pointer-events-none absolute -right-8 bottom-[-2.5rem] h-32 w-32 rounded-full bg-rose-300/20 blur-2xl
              motion-safe:animate-[drift_9s_ease-in-out_infinite_reverse]'
            aria-hidden='true'
          />

          <div
            className='relative rounded-full p-[0.1875rem] shadow-lg'
            style={{
              background:
                'conic-gradient(from 0deg, #BFD8FF, #FFFFFF, #BFD8FF)',
            }}
          >
            <span className='block rounded-full bg-primary p-[0.0625rem]'>
              <AvatarComponent
                src={user?.picture}
                alt={'user'}
                fallback={getAvatarFallback(user?.name, user?.email)}
              />
            </span>
          </div>

          <h4 className='relative text-center text-[1.0625rem] font-semibold leading-tight text-white drop-shadow-sm'>
            {user?.name}
          </h4>
          {user?.email && (
            <p className='relative text-center text-[0.75rem] font-medium leading-none text-white/75'>
              {user.email}
            </p>
          )}
        </div>

        {/* Action list */}
        <div className='flex flex-col gap-[0.125rem] p-[0.625rem]'>
          <button
            type='button'
            onClick={() => navigate('/settings')}
            className='group flex w-full items-center gap-[0.75rem] rounded-[0.625rem] px-[0.625rem] py-[0.5rem]
              text-left transition-colors duration-150 hover:bg-info/10'
          >
            <span
              className='flex flex-shrink-0 items-center justify-center rounded-full bg-info/10
                transition-transform duration-200 group-hover:rotate-45'
              style={{ width: 26, height: 26 }}
            >
              <SettingsGearIcon />
            </span>
            <span className='text-[1rem] font-medium leading-tight text-primary-foreground transition-colors group-hover:text-info'>
              Settings
            </span>
          </button>

          <button
            type='button'
            id='tour-start-btn'
            onClick={() => {
              dispatch(setWebTour(true))
              startTour()
            }}
            title='Start Web Tour'
            className='group flex w-full items-center gap-[0.75rem] rounded-[0.625rem] px-[0.625rem] py-[0.5rem]
              text-left transition-colors duration-150 hover:bg-danger/10'
          >
            <span
              className='flex flex-shrink-0 items-center justify-center rounded-full bg-danger/10'
              style={{ width: 26, height: 26 }}
            >
              <BinocularsIcon />
            </span>
            <span className='text-[1rem] font-medium leading-tight text-primary-foreground'>
              Web Tour
            </span>
          </button>

          <button
            type='button'
            onClick={() =>
              logout({
                logoutParams: { returnTo: `${window.location.origin}/app` },
              })
            }
            className='group flex w-full items-center gap-[0.75rem] rounded-[0.625rem] px-[0.625rem] py-[0.5rem]
              text-left transition-colors duration-150 hover:bg-danger/10'
          >
            <span
              className='flex flex-shrink-0 items-center justify-center rounded-full bg-danger/10
                transition-transform duration-200 group-hover:translate-x-0.5'
              style={{ width: 26, height: 26 }}
            >
              <SignOutIcon />
            </span>
            <span className='text-[1rem] font-medium leading-tight text-danger'>
              Sign Out
            </span>
          </button>
        </div>

        <div className='h-px w-full bg-border/70' />

        {/* Build Version row */}
        <div className='flex w-full items-center justify-between bg-primary px-[1rem] py-[0.25rem]'>
          <p className='font-sans text-[0.75rem] font-normal text-secondary-foreground'>
            Build Version
          </p>
          <p className='font-sans text-[0.75rem] font-normal text-secondary-foreground'>
            v{appVersion} (Build {build})
          </p>
        </div>
      </PopoverContent>
    </Popover>
  )
}
